import React from "react";
import useInitializeLead360 from "../../hooks/useInitializeLead360.js";
import ReactGrid from "../../components/ReactGrid/index.jsx";
import WidgetWrapper from "./widgetWrapper.jsx";
import Skeleton from "../../components/Skeleton/index.jsx";
import * as styles from "./style.module.css";
import RetryComponent from "../../components/RetryComponent/RetryComponent.jsx";
import { onWidgetClick } from "../../utils/helpers.js";

const Lead360 = () => {
  const { loading, error, widgetMap, pageConfig, initialize } =
    useInitializeLead360();
  const gridConfig = {
    className: styles.lead360GridWrapper,
    layouts: { lg: pageConfig },
    breakpoints: { lg: 956, xxs: 320 },
    cols: { lg: 16, xxs: 4 },
    rowHeight: 20,
    margin: [16, 16],
    containerPadding: [5, 0],
    isDraggable: false,
    isResizable: false,

  };

  if (loading) {
    return <Skeleton type="dashboard" />;
  }
  if (error) {
    if (window.lead360HelperUtils?.handleFallback) return null;
    return <RetryComponent onRetry={initialize} />;
  }

  return (
    <div className={styles.parentWrapper}>
      <ReactGrid config={gridConfig}>
        {pageConfig?.map((widget) => (
          <div
            data-grid={widget}
            key={widget.id}
            className={styles.widgetWrapper}
            onClick={() => onWidgetClick(widgetMap[widget.id]?.config)}
          >
            <WidgetWrapper data-grid={widget} data={widgetMap[widget.id]} />
          </div>
        ))}
      </ReactGrid>
    </div>
  );
};

export default Lead360;
